exports.version="4.15.0"


//////////////////
// WEBPACK FOOTER
// ./~/ali-oss/lib/browser/version.js
// module id = 379
// module chunks = 0 1